<template>
  <!-- header -->
    <div style="background-color: white">
        <div class="has-background-src" style="text-align: center"><img
                src="../../../../public/GCC/8. Banner - Contactos.png"></div>


        <!-- body -->
        <div class="columns is-centered">
            <div class="column is-7">

                <b-collapse
                        class="card"
                        animation="slide"
                        v-for="(collapse, index) of collapses"
                        :key="index"
                        :open="isOpen == index"
                        @open="isOpen = index"
                        :aria-id="'contentIdForA11y5-' + index">
                    <template #trigger="props">
                        <div
                                class="card-header"
                                role="button"
                                :aria-controls="'contentIdForA11y5-' + index"
                                :aria-expanded="props.open">
                            <p class="card-header-title is-flex is-justify-content-left subtitle is-3-desktop is-5-mobile has-text-secondary has-text-weight-bold is-family-secondary ">

                                {{ collapse.titulo }}

                            </p>

                            <a class="card-header-icon">
                                <b-icon
                                        :icon="props.open ? 'fa-chevron-down' : 'fa-chevron-up'">
                                </b-icon>
                            </a>

                        </div>

                    </template>

                    <div class="card-content" v-for="(imagen,index) of collapse.imagenes" :key="index">
                        <img v-bind:src=imagen class="responsive"><img>

                    </div>

                </b-collapse>
            </div>
        </div>
        <!-- Footer -->

        <div style="background-color: #003B71" align="center">
            <img src="../../../../public/logo_sin_texto.png"/>
            <div>
                <a href="https://www.fing.usach.cl/" target="_blank">
                    <h1 class="is-size-6 has-text-warning has-text-centered is-family-secondary has-text-weight-bold">
                        WEB OFICIAL FING USACH | Entra aquí
                    </h1>
                </a>
                <br/>
            </div>

        </div>
        <div class="has-background-src" align="center">
            <br/>
            <h1 class="is-size-6 has-text-white has-text-centered is-family-secondary ">
                Universidad de Santiago de Chile. Avenida Libertador Bernardo O'Higgins nº 3363. Estación Central.
                Santiago. Chile.
            </h1>
            <a href="https://www.usach.cl/contacto" target="_blank">
                <h1 class="is-size-6 has-text-secondary has-text-centered is-family-secondary has-text-weight-bold">
                    Oficina de Informaciones, Reclamos y Sugerencias (OIRS)
                </h1>
            </a>
            <br/>

        </div>


    </div>

</template>

<script>

import Accordion from "../Tools/accordion";
import AccordionItem from "../Tools/accordion-item";


export default {
    name: "GccContactUs",
    components: {},
    data() {
        return {
            isOpen: 0,
            collapses: [
                {
                    'titulo': 'CERTIFICADOS',
                    'imagenes': [require('../../../../public/GCC/contacts/1.png')]
                },
                {
                    'titulo': 'PLANES Y PROGRAMAS',
                    'imagenes': [require('../../../../public/GCC/contacts/2.png')]
                }
            ]
        }
    },
  created() {
    document.title = "SRC | Contáctanos"
  },

};
</script>


<style>


.responsive {
    width: 100%;
    height: auto;
}

/* Solid border */

</style>
